export default "__VITE_ASSET__24ee0331__"